module.exports = __webpack_public_path__ + "img/icons-globe.f68c835a.svg";